import styled from 'styled-components';
import { TextField, Button } from '@mui/material';
import colors from '../../../../../styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 60%;
  height: 100%;
  overflow-y: auto;
`;

export const ConfigContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
  padding: 24px;
  background-color: ${colors.base.alpha};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: ${colors.base.beta};
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: ${colors.shades.gamma7};
  margin: 8px 0 0 0;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  
  & .MuiInputBase-root {
    font-size: 14px;
  }
`;

export const StyledButton = styled(Button)`
  align-self: flex-start;
  margin-top: 16px;
  text-transform: none;
  padding: 10px 24px;
  font-weight: 500;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
